import useStyles from './InputRow.styles';

interface InputRowProps {
  children: React.ReactNode;
  className?: string;
}

const InputRow: React.FC<InputRowProps> = ({ children, className }) => {
  const { classes, cx } = useStyles();

  return <div className={cx(classes.inputRow, className)}>{children}</div>;
};

export default InputRow;
